export * from '@taqueria/protocol/out/types/InstalledPlugin';
